<template>
<div class="main list-view no-sub-header">

	<div v-if="showFilters" class="left-sidebar filters">

		<!-- <div class="title">Select which settings you want to edit...</div> -->

		<div :class="['filter-list-button-large', settingSet == 'ANALYTICS'? 'active' : '']" @click="toggleSettings('ANALYTICS')">
			<div class="label">Analytics</div>
		</div>
		<div :class="['filter-list-button-large', settingSet == 'ABOUTSTORE'? 'active' : '']" @click="toggleSettings('ABOUTSTORE')">
			<div class="label">About</div>
		</div>
		<div :class="['filter-list-button-large', settingSet == 'CONTACTINFO'? 'active' : '']" @click="toggleSettings('CONTACTINFO')">
			<div class="label">Contact Info</div>
		</div>
		<div :class="['filter-list-button-large', settingSet == 'MAILCHIMP'? 'active' : '']" @click="toggleSettings('MAILCHIMP')">
			<div class="label">Mailchimp</div>
		</div>
		<div :class="['filter-list-button-large', settingSet == 'AGE_VERIFICATION'? 'active' : '']" @click="toggleSettings('AGE_VERIFICATION')">
			<div class="label">Age Verification</div>
		</div>
		<div :class="['filter-list-button-large', settingSet == 'OTHER'? 'active' : '']" @click="toggleSettings('OTHER')">
			<div class="label">Other</div>
		</div>

	</div>

	<div class="detail">
		
		<div class="main-content list-detail" v-if="!loading">
			<h1>{{ settingTitles[settingSet] }}</h1>

			<div v-if="settingSet == 'ANALYTICS'" class="two-columns settings-columns">
				<div class="settings-group">
					<label>Site Description</label>
					<input type="text" v-model="settings.site_description">
				</div>
				<div class="instruction">Enter a website description that search engines will use in their listings.</div>
				<div class="settings-group">
					<label>Site Keywords</label>
					<input type="text" v-model="settings.site_keywords">
				</div>
				<div class="instruction">Enter a comma-separated list of keywords to give search engines hints about your site's content.</div>
				<div class="settings-group">
					<label>Google Analytics Measurement ID</label>
					<input type="text" v-model="settings.analytics_code">
				</div>
				<div class="instruction">
					<div v-if="settings.analytics_code && settings.analytics_code.indexOf('G-') != 0" class="error v-spaced">Starting July 1, 2023, Google will no longer support existing codes. Instead, you'll need to use a Measurement ID. To find your Measurement ID, log in to Google Analytics, go to Admin, click on Data Streams, and then click the stream for details.</div>
					A Google Analytics Measurement ID looks like this: G-F18L0GJFGZ
				</div>
				<div class="settings-group">
					<label>Custom Header Tags</label>
					<input type="text" v-model="settings.custom_header_tags">
				</div>
				<div class="instruction">Enter the complete tag code like this...<br>&lt;meta name='p:domain_verify' content='xxx'/&gt;</div>
			</div>

			<div v-if="settingSet == 'ABOUTSTORE'" class="two-columns settings-columns">
				<div class="settings-group">
					<label>Tagline</label>
					<textarea v-model="settings.store_tagline" style="height: 5em;"></textarea>
				</div>
				<div class="instruction">Enter a brief tagline for your store, e.g. 'Always low prices'.<br>Your tagline will be displayed in your News Alerts section if you don't have any other news alerts set.</div>
				<div class="settings-group">
					<label>Store Hours</label>
					<textarea v-model="settings.store_hours" style="height: 10em;"></textarea>
				</div>
				<div class="instruction">Enter your store hours as you want them displayed on your website's contact and checkout pages.  Leave blank if you don't want to display store hours.</div>
			</div>

			<div v-if="settingSet == 'CONTACTINFO'" class="two-columns settings-columns">
				<div class="settings-group">
					<label>Company Name</label>
					<input type="text" v-model="settings.company_name">
					<label>Address</label>
					<input type="text" v-model="settings.address_1">
					<div class="three-columns">
						<label>City</label>
						<label>State</label>
						<label>Zip Code</label>
						<input type="text" v-model="settings.city">
						<input type="text" v-model="settings.state">
						<input type="text" v-model="settings.zip_code">
					</div>
					<div class="two-columns">
						<label>Phone Number</label>
						<label>Fax Number</label>
						<input type="text" v-model="settings.phone_number">
						<input type="text" v-model="settings.fax_number">
					</div>
					<label>Email Address</label>
					<input type="text" v-model="settings.email_address">
					<label class="checkbox with-outside-label">
						<input type="checkbox" v-model="settings.hide_email_address">
						<span><i class="fas fa-check-circle"></i></span>
						<span class="label-text">Hide email address on my website contact page</span>
					</label>
					<label class="checkbox with-outside-label">
						<input type="checkbox" v-model="settings.hide_store_address">
						<span><i class="fas fa-check-circle"></i></span>
						<span class="label-text">Hide store address on my website contact page</span>
					</label>
					<label class="checkbox with-outside-label">
						<input type="checkbox" v-model="settings.hide_subscribe">
						<span><i class="fas fa-check-circle"></i></span>
						<span class="label-text">Hide 'Subscribe to Our Mailing List' on my website contact page</span>
					</label>
				</div>
				<div class="instruction">Enter your store contact info as you want it displayed on your website's contact and checkout pages.</div>
			</div>

			<div v-if="settingSet == 'MAILCHIMP'" class="two-columns settings-columns">
				<div class="settings-group">
					<label>Mailchimp API Key</label>
					<input type="text" v-model="settings.mailchimp_api_key">
					<div :class="['button', 'inline', settings.mailchimp_api_key ? 'neutral' : 'disabled']" @click="getMailchimpLists()">Test API Key</div>
					<span class="label" style="margin: 0 0 0 1em;"><i>Test to get your Mailchimp list names</i></span>
				</div>
				<div class="instruction">You can find or create an API key in your Mailchimp account:<br>Profile -> Settings -> Users -> Extras -> API Keys.</div>
				<div class="settings-group">
					<label>Mailchimp List Name</label>
					<select v-model="settings.mailchimp_subscribe_list_id">
						<option value="">Select a list...</option>
						<option v-for="list in settings.mailchimp_lists" :value="list.id">{{ list.name }}</option>
					</select>
				</div>
				<div class="instruction">Select which list new subscribers will be added to.</div>
				<label class="checkbox with-outside-label">
					<input type="checkbox" v-model="settings.mailchimp_display_popup">
					<span><i class="fas fa-check-circle"></i></span>
					<span class="label-text">Enable Mailchimp subscribe popup</span>
				</label>
				<div class="instruction">Display a popup for site visitors to subscribe. Note that the Subscribe section will always be available on your Contact Us page.</div>
				<label class="checkbox with-outside-label">
					<input type="checkbox" v-model="settings.mailchimp_require_name">
					<span><i class="fas fa-check-circle"></i></span>
					<span class="label-text">Require name as well as email address</span>
				</label>
				<div class="instruction">When checked, site visitors will need to enter their name as well as their email address to subscribe.</div>
				<div class="settings-group">
					<label>Custom text with subscribe inputs</label>
					<textarea v-model="settings.mailchimp_extra_text" style="height: 5em;"></textarea>
				</div>
				<div class="instruction">Enter a brief message to display with your subscribe inputs, e.g. "We will never share your info with any other company."</div>
			</div>

			<div v-if="settingSet == 'AGE_VERIFICATION'" class="two-columns settings-columns">
				<div class="settings-group">
					<label>Minimum Age</label>
					<number-input :decimals='0' v-model="settings.website_minimum_age" :key="'website_minimum_age_' + settings.website_minimum_age" />
				</div>
				<div class="instruction">Customers must confirm their age.</div>
				<div class="settings-group" style="border: 1px solid #ccc; background-color: #f4f4f4; padding: 1em 1em 0 1em;">
					<p>Our website features Shooting Sports products.  Please confirm <span v-if="settings.website_minimum_age">that you are at least {{ settings.website_minimum_age }} years old</span><span v-else>your age</span> before entering.</p>
				</div>
				<div class="instruction">This is the default text that will be displayed in your age verificaiton popup.</div>
				<div class="settings-group">
					<label class="checkbox with-outside-label">
						<input type="checkbox" v-model="settings.website_minimum_age_use_custom_text" @click="toggleSettings('website_minimum_age_use_custom_text')">
						<span><i class="fas fa-check-circle"></i></span>
						<span class="label-text">Use your own custom text for your age verification popup</span>
					</label>
				</div>
				<div class="instruction"></div>
				<div v-if="settings.website_minimum_age_use_custom_text" class="settings-group">
					<label>Custom Text</label>
					<textarea v-model="settings.website_minimum_age_content" style="height: 5em;"></textarea>
				</div>
				<div v-if="settings.website_minimum_age_use_custom_text" class="instruction">If you don't want the default text, you can enter your custom text.</div>
			</div>

			<div v-if="settingSet == 'OTHER'" class="two-columns settings-columns">
				<div class="settings-group">
					<label>TawkTo Account Number</label>
					<input type="text" v-model="settings.tawkto">
				</div>
				<div class="instruction">This will enable the TawkTo chat app on your website.</div>
				<label class="checkbox with-outside-label">
					<input type="checkbox" v-model="settings.hide_website_login">
					<span><i class="fas fa-check-circle"></i></span>
					<span class="label-text">Hide the Flight Deck login link at the bottom of my website</span>
				</label>
				<div class="instruction">This helps prevent website visitors from trying to log in to your management programs.</div>

				<div class="settings-group">
					<label>Label for distributor item available (15 characters max)</label>
					<input type="text" maxlength="15" v-model="settings.distributor_item_label" style="width: 15em;">
				</div>
				<div class="instruction">Displayed with items not availalbe in store.  Default is "At Warehouse".</div>

			</div>

			<div class="controls detail-controls">
				<button class="button primary" @click="saveSettings()">Save {{ settingTitles[settingSet] }}</button>
			</div>

		</div>

        <loading v-else></loading>
	</div>

	<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<help-popup :helpLink="{88:'Website Settings', 89:'Analytics', 90:'About Settings', 91:'Contact Info', 394:'Mailchimp', 366:'Age Verification', 336:'Other Settings'}" :tours="false"></help-popup>

</div>
</template>

<script>
import NumberInput from '@/components/NumberInput.vue'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'settings',
	props: ['setting'],
    components: {
		'number-input': NumberInput,
		'help-popup': HelpPopup
	},
	data() {
		return {
			loading: false,
			showFilters: true,
			settingTitles: {
				'ANALYTICS': 'Tag and Analytics Settings',
				'ABOUTSTORE': 'About Your Store',
				'CONTACTINFO': 'Contact Info',
				'MAILCHIMP': 'Mailchimp Subscribe',
				'AGE_VERIFICATION': 'Age Verification Settings',
				'OTHER': 'Other Website Settings'
			},
			settingSet: '',
			settings: {},
			paymentProcessors: [],
			message: '',
			saving: false,
			messageStatus: '',
			messageTimeout: 0,
			clientId: ''
		}
	},
	created() {
		this.settingSet = this.setting ? this.setting.toUpperCase() : 'TAX'
		this.getSettings()
	},
	watch: {
		setting: function(which) {
			this.settingSet = this.setting.toUpperCase()
			this.getSettings()
		}
	},
	methods: {
		getSettings() {
            this.loading = true
			this.settings = {}
			this.apiCall({ destination: 'get_item_website_settings', data: { section: this.settingSet } }).then(obj => {
                this.loading = false
				this.settings = obj.settings
			}).catch(err => {
                this.loading = false
				console.log(err)
			})
		},
		toggleSettings(which) {
			if (which == 'website_minimum_age_use_custom_text') {
				if (!this.settings.website_minimum_age_use_custom_text) {
					this.settings.website_minimum_age_content = ''
				}
				return
			}
			if (which != this.settingSet) {
				this.$router.push('/website/settings/' + which.toLowerCase())
			}
		},
		saveSettings() {
			if (this.saving) { return }
			this.message = 'Saving website settings...'
			this.saving = true
			this.apiCall({ destination: 'save_item_website_settings', data: { section: this.settingSet, settings: this.settings } }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				if (this.messageStatus == 'success') {
					this.message = 'Website settings saved.'
					this.messageTimeout = 2
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getMailchimpLists() {
			if (this.saving || !this.settings.mailchimp_api_key) { return }
			this.message = 'Testing Mailchimp API Key...'
			this.saving = true
			this.apiCall({ destination: 'test_mailchimp_api_key', data: { mailchimp_api_key: this.settings.mailchimp_api_key } }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				if (this.messageStatus == 'success') {
					this.settings.mailchimp_lists = obj.lists
					this.message = 'Mailchimp API Key is valid!'
					this.messageTimeout = 2
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})

		}
	}
}
</script>

<style lang="scss" scoped>
.settings-columns {
	align-items: center;
}
.settings-group {
	margin: 0 0 1em 0;
}
</style>
